import React, { ReactElement } from 'react';
import cn from 'classnames/bind';
import { getFullNameForUser } from 'utils';
import { getPrettyFormattedDateTime } from 'utils/dates';
import {
  ObjectHistoryFormat,
  ObjectHistoryProps,
  ObjectHistorySource,
} from './types';

export function ObjectHistory(props: ObjectHistoryProps): ReactElement {
  const {
    object,
    format = ObjectHistoryFormat.FullText,
    className,
    source,
    showCreated = false,
  } = props;
  const { objectHistory } = object ?? {};
  if (!objectHistory) {
    return null;
  }
  const lastUpdated = objectHistory.updatedAt ?? objectHistory.createdAt;
  const lastUpdatedBy = objectHistory.updatedBy ?? objectHistory.createdBy;
  const { createdAt, createdBy } = objectHistory;

  const updatedName = lastUpdatedBy ? getFullNameForUser(lastUpdatedBy) : null;
  const updatedTimeStamp = getPrettyFormattedDateTime(lastUpdated);
  const createdName = createdBy ? getFullNameForUser(createdBy) : null;
  const createdTimeStamp = getPrettyFormattedDateTime(createdAt);

  let sourcePrefix = '';
  if (source === ObjectHistorySource.JobsiteWorker) {
    sourcePrefix = 'Worker jobsite specific data';
  }

  const messages: Array<{ key: string; text: string }> = [];

  // Add created message (only for FullText format)
  if (format === ObjectHistoryFormat.FullText && createdAt && showCreated) {
    const createdMessage = `${sourcePrefix} ${sourcePrefix ? 'c' : 'C'}reated ${
      createdName ? `by ${createdName}` : ''
    } on ${createdTimeStamp}`;
    messages.push({ key: 'created', text: createdMessage });
  }

  // Add updated message
  let updatedMessage = `${sourcePrefix} ${
    sourcePrefix ? 'l' : 'L'
  }ast updated ${
    updatedName ? `by ${updatedName}` : ''
  } on ${updatedTimeStamp}`;
  if (format === ObjectHistoryFormat.TimeName) {
    updatedMessage = `${updatedTimeStamp}${
      updatedName ? ` by ${updatedName}` : ''
    }`;
  } else if (format === ObjectHistoryFormat.NameTime) {
    updatedMessage = `${
      updatedName ? `${updatedName} ` : ''
    } on ${updatedTimeStamp}`;
  } else if (format === ObjectHistoryFormat.Time) {
    updatedMessage = updatedTimeStamp;
  } else if (format === ObjectHistoryFormat.Name) {
    updatedMessage = updatedName;
  }
  messages.push({ key: 'updated', text: updatedMessage });

  return (
    <div className={cn('object-history', className)}>
      {messages.map((msg) => (
        <div key={msg.key}>{msg.text}</div>
      ))}
    </div>
  );
}
